module.exports={
  "pleat_size": [
    {
      "label": "25mm",
      "value": "25mm"
    },
    {
      "label": "32mm",
      "value": "32mm"
    },
    {
      "label": "45mm",
      "value": "45mm"
    },
    {
      "label": "62mm",
      "value": "62mm"
    },
    {
      "label": "77mm",
      "value": "77mm"
    }
  ],
  "material": [
    {
      "label": "Sheer",
      "value": "sheer"
    },
    {
      "label": "Light Filtering",
      "value": "light_filtering"
    },
    {
      "label": "Room Darkening",
      "value": "room_darkening"
    }
  ],
  "color": [
    {
      "value": "C5004",
      "label": "Cloud White",
      "material": "sheer",
      "image": "C5004.jpg"
    },
    {
      "value": "C5001",
      "label": "Seapearl",
      "material": "sheer",
      "image": "C5001.jpg"
    },
    {
      "value": "C5002",
      "label": "Cloudy Chiffon",
      "material": "sheer",
      "image": "C5002.jpg"
    },
    {
      "value": "C5501",
      "label": "Jersey Cream",
      "material": "sheer",
      "image": "C5501.jpg"
    },
    {
      "value": "C5201",
      "label": "Nightfall",
      "material": "sheer",
      "image": "C5201.jpg"
    },
    {
      "value": "C2001",
      "label": "Bright White",
      "material": "light_filtering",
      "image": "C2001.jpg"
    },
    {
      "value": "C2002",
      "label": "Marshmallow",
      "material": "light_filtering",
      "image": "C2002.jpg"
    },
    {
      "value": "C2501",
      "label": "Creamy",
      "material": "light_filtering",
      "image": "C2501.jpg"
    },
    {
      "value": "C2003",
      "label": "Ivory",
      "material": "light_filtering",
      "image": "C2003.jpg"
    },
    {
      "value": "C2506",
      "label": "Flax",
      "material": "light_filtering",
      "image": "C2506.jpg"
    },
    {
      "value": "C2507",
      "label": "Pebble",
      "material": "light_filtering",
      "image": "C2507.jpg"
    },
    {
      "value": "C2402",
      "label": "Chocolate",
      "material": "light_filtering",
      "image": "C2402.jpg"
    },
    {
      "value": "C2104",
      "label": "Shale",
      "material": "light_filtering",
      "image": "C2104.jpg"
    },
    {
      "value": "C2202",
      "label": "Graphite",
      "material": "light_filtering",
      "image": "C2202.jpg"
    },
    {
      "value": "C2109",
      "label": "Crystal",
      "material": "light_filtering",
      "image": "C2109.jpg"
    },
    {
      "value": "C2706",
      "label": "Sky",
      "material": "light_filtering",
      "image": "C2706.jpg"
    },
    {
      "value": "C2303",
      "label": "Petal",
      "material": "light_filtering",
      "image": "C2303.jpg"
    },
    {
      "value": "C2108",
      "label": "Heather",
      "material": "light_filtering",
      "image": "C2108.jpg"
    },
    {
      "value": "C4508",
      "label": "Sand",
      "material": "room_darkening",
      "image": "C4508.jpg"
    },
    {
      "value": "C4504",
      "label": "Desert",
      "material": "room_darkening",
      "image": "C4504.jpg"
    },
    {
      "value": "C4506",
      "label": "Primrose",
      "material": "room_darkening",
      "image": "C4506.jpg"
    },
    {
      "value": "C4507",
      "label": "Tamarind",
      "material": "room_darkening",
      "image": "C4507.jpg"
    },
    {
      "value": "C4201",
      "label": "Black Ink",
      "material": "room_darkening",
      "image": "C4201.jpg"
    },
    {
      "value": "C4105",
      "label": "Dusk",
      "material": "room_darkening",
      "image": "C4105.jpg"
    },
    {
      "value": "C4101",
      "label": "Steel Gray",
      "material": "room_darkening",
      "image": "C4101.jpg"
    },
    {
      "value": "C4103",
      "label": "Mineral",
      "material": "room_darkening",
      "image": "C4103.jpg"
    },
    {
      "value": "C4704",
      "label": "Indigo",
      "material": "room_darkening",
      "image": "C4704.jpg"
    },
    {
      "value": "C4601",
      "label": "Fog Green",
      "material": "room_darkening",
      "image": "C4601.jpg"
    },
    {
      "value": "C4104",
      "label": "Slate",
      "material": "room_darkening",
      "image": "C4104.jpg"
    },
    {
      "value": "C4102",
      "label": "Terra",
      "material": "room_darkening",
      "image": "C4102.jpg"
    },
    {
      "value": "C4705",
      "label": "Topaz",
      "material": "room_darkening",
      "image": "C4705.jpg"
    },
    {
      "value": "C4001",
      "label": "Glacier White",
      "material": "room_darkening",
      "image": "C4001.jpg"
    },
    {
      "value": "C4108",
      "label": "Infinity",
      "material": "room_darkening",
      "image": "C4108.jpg"
    },
    {
      "value": "C4412",
      "label": "Ecru",
      "material": "room_darkening",
      "image": "C4412.jpg"
    },
    {
      "value": "C4111",
      "label": "Champagne",
      "material": "room_darkening",
      "image": "C4111.jpg"
    }
  ],
  "control_side": [
    {
      "label": "Left",
      "value": "left"
    },
    {
      "label": "Right",
      "value": "right"
    }
  ],
  "stack_side": [
    {
      "label": "Left",
      "value": "left"
    },
    {
      "label": "Right",
      "value": "right"
    },
    {
      "label": "Split",
      "value": "split"
    }
  ]
}